import React, { useState, useEffect, useRef } from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "BoG Solitaire",
      description: "Developed a Spider Solitaire game on the Godot v4.3 Game Engine using C#. The game was build following OOP conventions with features such as undo logic and game state save in case of a crash.",
      technologies: ["Godot", "C#"],
      media: [
        { type: "image", src: "/media/bog-solitaire.jpg" },
        { type: "video", src: "/media/bog-solitaire.mp4" },
      ],
    },
    {
      id: 2,
      title: "Parking Chaos",
      description: "Built a car park based puzzle game on the Godot v4.3 Game Engine using C#. The game features multiple different level designs with two different sizes of the playable arena, a level reset button, game save function, score tracking, level time tracking with the player's best time being saved. Each level's puzzal is randomly generated so no two levels will ever be the same.",
      technologies: ["Godot", "C#"],
      media: [
        { type: "image", src: "/media/parking-chaos.jpg" },
        { type: "image", src: "/media/parking-chaos-2.jpg" },
        { type: "image", src: "/media/parking-chaos-3.jpg" },
        { type: "video", src: "/media/parking-chaos.mp4" },
      ],
    },
    {
      id: 3,
      title: "Portfolio Website",
      description: "Designed and developed a personal portfolio website to showcase projects, skills, and experience with a modern UI.",
      technologies: ["React", "TypeScript", "CSS", "Netlify"],
      media: [
        { type: "image", src: "/media/portfolio.jpg" },
      ],
    },
  ];

  const Slideshow = ({ media }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const videoRef = useRef(null);
    const intervalRef = useRef(null);

    // Start or stop the slideshow interval based on video playback
    useEffect(() => {
      const startInterval = () => {
        intervalRef.current = setInterval(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
        }, 5000);
      };

      const stopInterval = () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };

      // If the current media is not a video or the video is not playing, start the interval
      if (media[currentIndex].type !== "video" || !isVideoPlaying) {
        startInterval();
      } else {
        stopInterval();
      }

      return () => stopInterval(); // Cleanup on unmount or index change
    }, [currentIndex, isVideoPlaying, media]);

    // Handle video playback events
    const handlePlay = () => {
      setIsVideoPlaying(true);
    };

    const handleEnded = () => {
      setIsVideoPlaying(false);
      // Advance to the next media when the video ends
      setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
    };

    const handlePrev = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + media.length) % media.length);
      setIsVideoPlaying(false); // Reset video playing state
      if (videoRef.current) {
        videoRef.current.pause(); // Pause the video if switching
      }
    };

    const handleNext = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
      setIsVideoPlaying(false); // Reset video playing state
      if (videoRef.current) {
        videoRef.current.pause(); // Pause the video if switching
      }
    };

    return (
      <div className="slideshow">
        <div className="slideshow-media">
          {media[currentIndex].type === "image" ? (
            <img src={media[currentIndex].src} alt={`Slide ${currentIndex}`} className="slide" />
          ) : (
            <video
              ref={videoRef}
              src={media[currentIndex].src}
              controls
              className="slide"
              onPlay={handlePlay}
              onEnded={handleEnded}
            />
          )}
        </div>
        <button className="slideshow-button prev" onClick={handlePrev}>❮</button>
        <button className="slideshow-button next" onClick={handleNext}>❯</button>
      </div>
    );
  };

  return (
    <section id="projects" className="projects-section">
      <h1 className="projects-title-box">PROJECTS</h1>
      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <Slideshow media={project.media} />
            <h2>{project.title}</h2>
            <p className="project-description">{project.description}</p>
            <div className="project-technologies">
              {project.technologies.map((tech, index) => (
                <span key={index} className="tech-tag">{tech}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;